import React from 'react';
import { Box } from '@chakra-ui/react';
import { MutatingDots } from 'react-loader-spinner';
import { Atom } from 'react-loading-indicators';
import { useLoader } from '../../contexts/LoaderContext';

const GlobalLoader = () => {
  const { isGlobalLoading } = useLoader();

  if (!isGlobalLoading) return null;

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      // bg="rgba(255, 255, 255, 0.8)"
      bg="rgba(255, 255, 255, 0.1)"
      sx={{
        backdropFilter: 'blur(5px)',
        WebkitBackdropFilter: 'blur(5px)',
      }}
      opacity="1"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex="9999"
    >
      {/* <MutatingDots
        visible={true}
        height="100"
        width="100"
        color="#9dc9f2"          // primary (matches your app tone)
        secondaryColor="#a1f4df" // secondary accent
        radius="12.5"
        ariaLabel="mutating-dots-loading"
      /> */}
      <Atom color="#32cd32" size="medium" text="" textColor="" />
    </Box>
  );
};

export default GlobalLoader;
